module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av164-be8d11c31662cf82096ee907e894774f.jpg";